import React from 'react';
import { Chip } from '@mui/material';

// One status look for the whole app: a small soft-tone badge. The theme's
// MuiChip override does the styling; this only maps a semantic tone to the
// Chip colour. Tones: success | error | warning | info | primary | neutral.
// Status vocabularies that repeat across pages map to tones in statusTones.js.
const TONE_TO_COLOR = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
    primary: 'primary',
    neutral: 'default',
};

export default function StatusChip({ tone = 'neutral', size = 'small', ...props }) {
    return <Chip size={size} color={TONE_TO_COLOR[tone] || 'default'} {...props} />;
}
